export enum BookingNoticeVariant {
  CreditCard = 'creditCard',
  Deposit = 'deposit',
  GuaranteeNoPartner = 'guaranteeNoPartner'
}
